import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { AppConstants } from '../../constants';

const { ROUTING } = AppConstants;

interface IProps {
  label: string;
  loanAccountId: string;
  toTab: string;
}

@observer
class LoanAccountTabNavLink extends Component<IProps> {
  public render () {
    const { label, loanAccountId, toTab } = this.props;

    return (
      <LinkContainer to={`${ROUTING.loanAccounts}/${loanAccountId}/${toTab}`}>
        <NavItem className={`nav-loan-account-main-${toTab}`}>{label}</NavItem>
      </LinkContainer>
    );
  }
}

export default LoanAccountTabNavLink;
